"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketApiTxStatus = exports.SocketApiAckStatus = exports.SocketApi = void 0;
const rxjs_1 = require("rxjs");
const messages_1 = require("./proto/messages");
const socket_connector_1 = require("./socket_connector");
const uuid_1 = require("uuid");
const socket_messages_1 = require("./socket_messages");
class SocketApi {
    constructor(host) {
        this.noCache = false;
        this._token = null;
        this.apiVersion = 1;
        this.logging = false;
        this._txMessageHandlers = new Map();
        this._messageHandlers = new Map();
        this._messageConverters = new Map();
        this.authenticatedChanges = new rxjs_1.Subject();
        this.connection = new socket_connector_1.SocketConnector(host);
        this.connection.rx.subscribe((e) => this._onData(e));
        this.setMessages(messages_1.proto.rxMessages);
    }
    get authenticated() {
        return this._token !== null;
    }
    ;
    get whenAuthenticated() {
        return new Promise((resolve) => {
            if (this.authenticated) {
                resolve(null);
            }
            else {
                this.authenticatedChanges
                    .pipe((0, rxjs_1.first)((v => v)))
                    .subscribe((e) => resolve(null));
            }
        });
    }
    setAuth(token) {
        if (this._token !== token) {
            this._token = token;
            this.authenticatedChanges.next(this.authenticated);
        }
    }
    getMessageHandler(message) {
        if (!this._messageConverters.has(message.messageType)) {
            this._messageConverters.set(message.messageType, message);
        }
        if (!this._messageHandlers.has(message.messageType)) {
            this._messageHandlers.set(message.messageType, new rxjs_1.Subject());
        }
        return this._messageHandlers.get(message.messageType);
    }
    setMessages(messages) {
        for (const message of messages) {
            this._messageConverters.set(message.messageType, message);
        }
    }
    sendMessage(message, { ack = false, timeoutMs = 10000 } = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = this._txMessageHandlers.get(message.messageType)) === null || _a === void 0 ? void 0 : _a.next(message);
            const instanceUuid = (0, uuid_1.v4)();
            const msg = JSON.stringify({
                'body': message.data,
                'headers': {
                    'messageType': message.messageType,
                    'authHeader': this._token,
                    'eventTime': Date.now(),
                    'localTime': Date.now(),
                    'ack': ack,
                    'retryCount': 0,
                    'apiVersion': this.apiVersion,
                    'uuid': instanceUuid,
                }
            });
            if (this.logging)
                console.log('txevent:', msg);
            try {
                this.connection.send(msg);
            }
            catch (e) {
                console.log('error sending', e);
                return new SocketApiTxStatus(SocketApiAckStatus.connectionError, 'Error sending the message.');
            }
            if (ack) {
                return yield this._waitAck(instanceUuid, timeoutMs);
            }
            else {
                return new SocketApiTxStatus(SocketApiAckStatus.success, '');
            }
        });
    }
    _waitAck(instanceUuid, timeoutMs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const msg = yield (0, rxjs_1.firstValueFrom)(this.getMessageHandler(new messages_1.proto.RxAck())
                    .pipe((0, rxjs_1.filter)((event) => event.proto.uuid === instanceUuid))
                    .pipe((0, rxjs_1.timeout)({ first: timeoutMs })));
                const status = msg.proto.errorMessage.length > 0 ? SocketApiAckStatus.messageError : SocketApiAckStatus.success;
                return new SocketApiTxStatus(status, msg.proto.errorMessage, msg.proto.asyncProgressKey.length > 0
                    ? this.getMessageHandler(new messages_1.proto.RxAsyncProgress())
                        .pipe((0, rxjs_1.filter)((event) => event.proto.key === msg.proto.asyncProgressKey))
                    : null);
            }
            catch (e) {
                // timeout
                return new SocketApiTxStatus(SocketApiAckStatus.timeout, 'No response from server.');
            }
        });
    }
    _onData(event) {
        var _a, _b;
        if (this.logging)
            console.log('rxevent:', event);
        const messageData = new socket_messages_1.SocketRxMessageData(event);
        const message = (_a = this._messageConverters.get(messageData.messageType)) === null || _a === void 0 ? void 0 : _a.fromMessage(messageData);
        if (message == null)
            return; // todo proper logging
        (_b = this._messageHandlers.get(messageData.messageType)) === null || _b === void 0 ? void 0 : _b.next(message);
    }
}
exports.SocketApi = SocketApi;
var SocketApiAckStatus;
(function (SocketApiAckStatus) {
    SocketApiAckStatus[SocketApiAckStatus["success"] = 0] = "success";
    SocketApiAckStatus[SocketApiAckStatus["connectionError"] = 1] = "connectionError";
    SocketApiAckStatus[SocketApiAckStatus["timeout"] = 2] = "timeout";
    SocketApiAckStatus[SocketApiAckStatus["messageError"] = 3] = "messageError";
})(SocketApiAckStatus = exports.SocketApiAckStatus || (exports.SocketApiAckStatus = {}));
class SocketApiTxStatus {
    constructor(status, errorMessage = null, asyncProgress = null) {
        this._asyncResult = null;
        this.status = status;
        this.errorMessage = errorMessage;
        this.asyncProgress = asyncProgress;
    }
    isAsync() {
        return this.asyncProgress !== null;
    }
    asyncResult({ timeoutMs = null }) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            if (!this.isAsync)
                return resolve(this);
            if (this._asyncResult !== null)
                return resolve(this._asyncResult);
            try {
                const msg = yield (0, rxjs_1.firstValueFrom)(this
                    .asyncProgress
                    .pipe((0, rxjs_1.first)((event) => event.proto.done))
                    .pipe((0, rxjs_1.timeout)({ first: (timeoutMs || 1e9) })));
                const msgStatus = msg.proto.errorMessage.length > 0 ? SocketApiAckStatus.messageError : SocketApiAckStatus.success;
                this._asyncResult = new SocketApiTxStatus(msgStatus, msg.proto.errorMessage);
            }
            catch (e) {
                // timeout
                this._asyncResult = new SocketApiTxStatus(SocketApiAckStatus.timeout, 'No response from server.');
            }
            return this._asyncResult;
        }));
    }
}
exports.SocketApiTxStatus = SocketApiTxStatus;
